










import {Vue, Component} from "vue-property-decorator";

@Component
export default class BillingInfoSelectSection extends Vue{
    pushInput(){
        this.$store.dispatch('billingInfo/pushProgress', "input");
    }
}
